/* -disable no-return-assign */
import React, { Component } from 'react';
import Slider from 'react-slick';

import { PrevArrow, NextArrow } from './CustomArrows';

import './react-slick.css';

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prevArrowActive: false,
      nextArrowActive: true,
      currentSlide: 1,
    };
  }

  componentDidMount() {
    const { initialSlide } = this.props;
    if (initialSlide) {
      setTimeout(() => {
        this.slider.slickGoTo(initialSlide);
      }, 150);
    }
  }

  _setPrevArrowActive = value => {
    this.setState({
      prevArrowActive: value,
    });
  };

  _setNextArrowActive = value => {
    this.setState({
      nextArrowActive: value,
    });
  };

  render() {
    const { prevArrowActive, nextArrowActive, currentSlide } = this.state;

    const { listLength, children, footerInfo, onChangeSlide } = this.props;
    const settings = {
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      // initialSlide,
      nextArrow: <NextArrow nextArrowActive={nextArrowActive} />,
      prevArrow: <PrevArrow prevArrowActive={prevArrowActive} />,
      afterChange: current => {
        if (current === 0) {
          this._setPrevArrowActive(false);
        } else {
          this._setPrevArrowActive(true);
        }
        if (current >= listLength - 1) {
          this._setNextArrowActive(false);
        } else {
          this._setNextArrowActive(true);
        }
        this.setState({ currentSlide: current + 1 });
        if (onChangeSlide) {
          onChangeSlide(current);
        }
      },
    };

    return (
      <div>
        <Slider
          ref={slider => (this.slider = slider)}
          afterChange={this._afterChangeHandler}
          {...settings}
        >
          {children}
        </Slider>
        {footerInfo && footerInfo(currentSlide)}
      </div>
    );
  }
}

export default Gallery;
